<!-- Brand. The page is RTL, so the mark leads on the right and the wordmark follows it. -->
<a class="flex items-center gap-2.5" routerLink="/" aria-label="ایزی کالا">
	<span class="flex size-10.5 shrink-0 items-center justify-center rounded-xl border border-stroke-050">
		<ui-icon width="24" height="24" aria-hidden="true" iconName="easy-kala" />
	</span>
	<span class="flex flex-col items-start gap-0.5">
		<ui-icon
			class="text-gray-800"
			width="59"
			height="16"
			viewBox="0 0 88 24"
			aria-hidden="true"
			iconName="easy-kala-wordmark-fa" />
		<span class="text-2.25 font-medium text-gray-500">سامانه معاملات بورس‌کالا</span>
	</span>
</a>

<hr class="border-stroke-050" />

<!-- The سایر page's profile card, which this replaces on desktop, plus the gear to تنظیمات. -->
<section class="flex items-center gap-1 rounded-xl bg-gray-050 px-2.5 py-3" aria-labelledby="side-menu-user-name">
	<div class="flex min-w-0 flex-1 items-center gap-1.5">
		<ui-icon class="shrink-0 text-gray-700" width="30" height="30" aria-hidden="true" iconName="account" />

		<div class="flex min-w-0 flex-col items-start">
			<p
				id="side-menu-user-name"
				class="w-full truncate text-xs font-bold text-gray-900"
				data-cy="side-menu-user-name">
				{{ userName() }}
			</p>
			<a
				class="flex items-center gap-0.5 text-2.25 font-bold text-blue-500"
				data-cy="side-menu-account-link"
				[routerLink]="accountRoute">
				<span>حساب کاربری</span>
				<ui-icon class="shrink-0" width="16" height="16" aria-hidden="true" iconName="chevron-left" />
			</a>
		</div>
	</div>

	<a
		class="flex h-7.5 w-9 shrink-0 items-center justify-center rounded-lg text-gray-700"
		aria-label="تنظیمات"
		data-cy="side-menu-settings"
		[routerLink]="settingsRoute">
		<ui-icon width="20" height="20" aria-hidden="true" iconName="setting" />
	</a>
</section>

<nav class="flex min-h-0 flex-1 flex-col gap-1" aria-label="منوی اصلی">
	@for (item of items; track item.route) {
		@let active = isActive(item);
		<a
			[class]="
				'flex items-center gap-1 rounded-lg px-2.5 py-3 text-xs ' +
				(active ? 'bg-gray-050 font-bold text-gray-900' : 'font-medium text-gray-500')
			"
			[routerLink]="item.route"
			[attr.aria-current]="active ? 'page' : null"
			[attr.data-cy]="item.dataCy">
			<ui-icon class="shrink-0" width="16" height="16" aria-hidden="true" [iconName]="iconOf(item)" />
			<span class="min-w-0 flex-1 truncate text-right">{{ item.title }}</span>
			@if (active) {
				<ui-icon class="shrink-0" width="16" height="16" aria-hidden="true" iconName="chevron-left" />
			}
		</a>
	}

	<!-- Built like the rows above, but an action rather than a page: it raises the
		logout confirmation, so it is a keyboard-operable button, not a link. -->
	<a
		class="flex cursor-pointer items-center gap-1 rounded-lg px-2.5 py-3 text-xs font-medium text-red-500"
		role="button"
		tabindex="0"
		data-cy="side-menu-logout"
		(click)="onLogoutClick()"
		(keydown.enter)="onLogoutClick()"
		(keydown.space)="$event.preventDefault(); onLogoutClick()">
		<ui-icon class="shrink-0" width="16" height="16" aria-hidden="true" iconName="kala-logout" />
		<span class="min-w-0 flex-1 truncate text-right">خروج</span>
	</a>
</nav>

<hr class="border-stroke-050" />

<footer dir="ltr" class="flex items-center justify-between">
	<div class="flex min-w-0 flex-col items-start gap-0.5 text-gray-400">
		<ui-icon width="62" height="16" viewBox="0 0 60 15" aria-label="EasyKala" iconName="easy-kala-wordmark" />
		@if (versionLabel(); as label) {
			<p class="truncate text-2.75" data-cy="side-menu-app-version">{{ label }}</p>
		}
	</div>

	<!-- Fetches and activates the latest build, then reloads — the سایر page's «راه اندازی مجدد». -->
	<ui-button
		variant="mute"
		iconOnly
		label="دریافت نسخه جدید"
		extraButtonClasses="!size-8"
		data-cy="side-menu-refresh"
		[disabled]="checkingForUpdate()"
		[attr.aria-busy]="checkingForUpdate()"
		(clicked)="onRefreshClick()">
		<ui-icon
			width="18"
			height="18"
			aria-hidden="true"
			iconName="refresh"
			[class.animate-spin]="checkingForUpdate()" />
	</ui-button>
</footer>

<app-logout-bottom-sheet #logoutSheet />
